var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseToolTipinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 48 48",
  height: 29,
  width: 29,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m14.379 35.493-1.759-1.759 9.677-9.677-9.677-9.678 1.759-1.759 9.678 9.677 9.677-9.677 1.759 1.759-9.677 9.678 9.677 9.677-1.759 1.759-9.677-9.677-9.678 9.677Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.205 44.577c11.425 0 20.684-9.261 20.684-20.683 0-11.425-9.259-20.684-20.684-20.684-11.422 0-20.683 9.259-20.683 20.684 0 11.422 9.261 20.683 20.683 20.683Zm0-1.724c10.471 0 18.96-8.488 18.96-18.959s-8.489-18.96-18.96-18.96-18.959 8.489-18.959 18.96 8.488 18.959 18.959 18.959Z"
})));
export default SvgCloseToolTipinline;